// extracted by mini-css-extract-plugin
module.exports = {"answer":"Ns","bestAnswerHeading":"Os","meta":"Ps"};